<template>
  <div class="main__search-field d-flex">
    <b-input-group>
      <template #prepend>
        <div class="input-group-prepend">
          <button class="bg-white" @click="search">
            <Tooltip text="Click search icon or press enter to search">
              <SearchIcon class="text-secondary" />
            </Tooltip>
          </button>
        </div>
      </template>
      <input
        id="searchElement"
        ref="filter"
        v-model="query"
        :placeholder="placeholder"
        type="text"
        autocomplete="off"
        name="query"
        class="form-control"
        @keyup="search"
      />
      <template #append>
        <div class="input-group-append d-flex">
          <button
            v-if="query.length > 0"
            class="mr-1 clear d-flex justify-content-center align-items-center clear-button"
            @click="clear"
          >
            x
          </button>
        </div>
      </template>
    </b-input-group>
    <!-- prevent from autofill, autocomplete="off" doesnt work-->
    <input ref="email" type="text" name="email" class="form-control autofill" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import Tooltip from '@/views/Components/Elements/Tooltip.vue'
import SearchIcon from '@/views/Components/Elements/Icons/SearchIcon.vue'

export default defineComponent({
  name: 'SearchField',
  components: {
    Tooltip,
    SearchIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search...',
    },
  },
  emits: ['searchTriggered'],
  setup(_, { emit }) {
    const show = ref(false)
    const query = ref('')

    const search = () => {
      emit('searchTriggered', query.value)
    }

    const clear = () => {
      show.value = false
      query.value = ''
      emit('searchTriggered', query.value)
    }

    return {
      show,
      query,
      search,
      clear,
    }
  },
})
</script>
